import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { OFFER_ANCHOR } from '../data/constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'gold';
  className?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const styles = variant === 'gold' ? 'bg-gold text-petrol-dark hover:bg-gold-hover' : 'bg-petrol text-white hover:bg-petrol-light';
  return <a href={href} className={`flex w-full items-center justify-center gap-2 rounded-xl px-5 py-3.5 text-center font-display text-sm font-extrabold uppercase leading-tight tracking-wide shadow-lg transition-colors duration-150 ease-out sm:text-base ${styles} ${className}`} data-id="element-54" data-mp="2p11jbi4ks701">
      <span data-id="element-55" data-mp="3cp2n6dqt6z94">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-56" data-mp="3cqdqkcgce4zp" />
    </a>;
}